import Product from '../Form/Product'

const PageProductNew = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
	
	return (
		<div id="ms-profile">

	        <div className="ms-section">
	        	<div className="ms-tab-profile ms-payment">
	        		<div className="ms-lateral-b">
				        <div className="ms-body-menu-profile">
				        	<div className="ms-info-menu-selected">
				        		<div className="ms-title">Nuevo Producto</div>
				        		<Product type_page="new" user={user} />
				        	</div>	        	
				        </div>
				    </div>
	        		
	        	</div>
            </div>

	        </div>
	)

}

export default PageProductNew;